import { useContext } from 'react'
import { config } from '../config';
import { PublicationContext } from '../context/PublicationContext';
import { useParams } from 'react-router-dom';
import { findTypeOption, typeLibrosOptions, typeLibro } from '../interfaces/Publication';

export const usePublication = () => {
    const { publication, changePublication } = useContext(PublicationContext);
    // const {todos} = todoState

    let { idRevista, idLibro } = useParams();
    const typeLibro: typeLibro = idLibro ? "libro" : "revista"
    const directory = findTypeOption(typeLibro)?.directory || ""
    const fileName = findTypeOption(typeLibro)?.fileName || ""

    return {
        publication: publication,
        sections: publication?.sections,
        currentSection: publication?.sections[publication.currentSection],
        path: `${config.urlJsonPublications}${directory}/${Math.floor(+publication?.id / 100)}/${publication?.id}/`,
        changePublication: changePublication
    }
}